export default class SessionAttendance {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    tenantID: 'validString',
    courseID: 'validString',
    userID: 'validString',
    sessionID: 'validString',
    attendanceStatus: 'validString',
    additionalNotes: 'validString?',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createSessionAttendance(sessionID, attendanceID, externalID, attendanceObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + `/attendance/${attendanceID}/${externalID}`;
    req.body = attendanceObj;
    return await req.exec();
  }
  async updateSessionAttendance(sessionID, attendanceID, externalID, attendanceObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/session/' + sessionID + `/attendance/${attendanceID}/${externalID}`;
    req.body = attendanceObj;
    return await req.exec();
  }
  async deleteSessionAttendance(sessionID, attendanceID, externalID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/session/' + sessionID + `/attendance/${attendanceID}/${externalID}`;
    return await req.exec();
  }
  async getSessionAttendance(sessionID, attendanceID, externalID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + `/attendance/${attendanceID}/${externalID}`;
    return await req.exec();
  }
  async getSessionAttendancesBySessionID(sessionID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + '/attendances/';
    return await req.exec();
  }
}
